import { useEffect } from "react";
import FacilityAvailabilityForm from "@/v2/components/facility-availability/FacilityAvailabilityForm";

const AddFacilityAvailability = () => {
  useEffect(() => {
    document.title = "Add Facility Availability | Admin";
  }, []);

  return (
    <div className="space-y-6">
      <FacilityAvailabilityForm />
    </div>
  );
};

export default AddFacilityAvailability;
